module.exports = __webpack_public_path__ + "img/banner-arrow.25dde929.svg";